/**
 * CargoCollection
 *
 * @author Thacryba
 */
import {PageCollection, HttpExclude} from 'simpli-web-sdk'
import {InternationalRequest} from '@/helpers/InternationalRequest'
import {Cargo} from '@/model/resource/Cargo'

@HttpExclude()
export class CargoCollection extends PageCollection<Cargo> {
  constructor() {
    super(Cargo)
  }

  queryAsPage() {
    return this.listCargo()
  }

  async listCargo() {
    return await InternationalRequest.get(`/admin/cargo`, {
      params: this.params,
    })
      .name('listCargo')
      .as(this)
      .getResponse()
  }

  async listCsvCargo() {
    return await InternationalRequest.get(`/admin/cargo/export`, {
      params: this.params,
    })
      .name('listCargo')
      .as(this)
      .getResponse()
  }
}
